module.exports = __webpack_public_path__ + "img/bg_fotos.3c1c58cf.jpg";